import { combineReducers } from 'redux';

import { 
    YEAR_MASTER_KODE_TRAYEK, MASTER_DATA_TRAYEK_BALIK,
    SHOW_TABLE_DETAIL_TRAYEK_BALIK, MASTER_DATA_DETAIL_TRAYEK_BALIK,
    KODE_TRAYEK_MASTER_BALIK, MASTER_DATA_BARANG_PERUAS, MODAL_BARANG_PERUAS,
    MASTER_DATA_CONSIGNE, MASTER_DATA_PELABUHAN
} from '../../actions/constant';

import {
  MUATAN_PER_VOYAGE_NEW_LOADING, MUATAN_PER_VOYAGE_NEW_SUCCESS, MUATAN_PER_VOYAGE_NEW_ERROR,
  DETAIL_PER_VOYAGES, SET_DETAIL_CONTAINER
} from '../../actions/reportTblTrayekBalikAction';

const showTable = (state = false, action) => {
  switch (action.type){
    case SHOW_TABLE_DETAIL_TRAYEK_BALIK:
      return action.val
    default:
      return state
  }
};

const listConsigne = (state = {isload:false, data:[]}, action) => {
  switch (action.type){
    case MASTER_DATA_CONSIGNE:
      return {isload:action.isload, data:action.val}
    default:
      return state
  }
};

const listPelabuhan = (state = {isload:false, data:[]}, action) => {
  switch (action.type){
    case MASTER_DATA_PELABUHAN:
      return {isload:action.isload, data:action.val}
    default:
      return state
  }
};

const modalBarangPeruas = (state = false, action) => {
  switch (action.type){
    case MODAL_BARANG_PERUAS:
      return action.val
    default:
      return state
  }
};

const barangPeruas = (state = {data:[], isLoad:false}, action) => {
  switch (action.type){
    case MASTER_DATA_BARANG_PERUAS:
      return {data:action.val, isLoad:action.load}
    default:
      return state
  }
};

const Years = (state = {data:[], isLoad:false}, action) => {
  switch (action.type) {
    case YEAR_MASTER_KODE_TRAYEK:
      return {data:action.val, isLoad:action.load}
    default:
      return state
  }
};

const kodeTrayeks = (state = {data:[], isLoad:false}, action) => {
  switch (action.type) {
    case KODE_TRAYEK_MASTER_BALIK:
      return {data:action.val, isLoad:action.load}
    default:
      return state
  }
};

const masterDataTrayekBalik = (state= {data:{data:[]}, isLoad:false}, action) => {
  switch(action.type) {
    case MASTER_DATA_TRAYEK_BALIK:
      return {data:action.val, isLoad:action.load}
    default:
      return state
  }
};

const detailDataTrayekBalik = (state= {data:{data:[], isLoad:false}}, action) => {
  switch(action.type) {
    case MASTER_DATA_DETAIL_TRAYEK_BALIK:
      return {data:action.val, isLoad:action.load}
    default:
      return state
  }
};

const getDetailVoyagePerTrayek = (state = {isload:false, data:[]}, action) => {
  switch (action.type){
    case DETAIL_PER_VOYAGES:
      return {isload:action.isload, data:[action.val]}
    default:
      return state
  }
};

const getDetailContainer = (state = {isload:false, data:[]}, action) => {
  switch (action.type){
    case "DETAIL_CONTAINER":
      return {isload:action.isload, data:action.val}
    default:
      return state
  }
};

const muatanVoyage = (state = {data: [], loading: false, error: false, success: false, kode : ''}, action) => {
  switch(action.type){
    case MUATAN_PER_VOYAGE_NEW_LOADING:
      return {
        ...state,
        kode: action.kode,
        loading: action.loading
      }
    case MUATAN_PER_VOYAGE_NEW_SUCCESS:
      return {
        ...state,
        kode: action.kode,
        data: action.data,
        success: action.success
      }
    case MUATAN_PER_VOYAGE_NEW_ERROR:
      return {
        ...state,
        kode: action.kode,
        error: action.error
      }
    default:
      return state
  }
};

const setFilterDetailContainer = (state = {data:[]}, action) => {
  switch (action.type){
    case SET_DETAIL_CONTAINER:
      return {data: action.val}
    default:
      return state
  }
};

const R_tblTrayekBalik = combineReducers({
  Years,
  kodeTrayeks,
  showTable,
  masterDataTrayekBalik,
  detailDataTrayekBalik,
  modalBarangPeruas,
  barangPeruas,
  listConsigne, 
  listPelabuhan,
  muatanVoyage,
  getDetailVoyagePerTrayek,
  getDetailContainer,
  setFilterDetailContainer
});
  
export default R_tblTrayekBalik;